import {
  auditReportsGetReportRunsCatalogArtifactUrl,
  AuditReportsReportRun,
} from '@mi-front/api-v2';
import DownloadIcon from '@mui/icons-material/Download';
import { Button } from '@mui/material';
import { downloadFile, sleep } from '@mi-front/core';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { hasPackageArtifactReady } from './broadcast-evidence-config';

interface Props {
  report: AuditReportsReportRun;
}

/**
 * Downloads the primary evidence package (zip) for a finished broadcast evidence run.
 */
export function BroadcastEvidencePackageDownload({ report }: Props) {
  const { $t } = useIntl();
  const [fetching, setFetching] = useState(false);
  const ready = hasPackageArtifactReady(report);

  if (!ready) {
    return (
      <Button color="info" size="small" disabled startIcon={<DownloadIcon />} variant="outlined">
        <FormattedMessage
          id="audit.broadcastEvidence.downloadPending"
          defaultMessage="Paquete de evidencia no disponible"
        />
      </Button>
    );
  }

  return (
    <Button
      color="info"
      size="small"
      disabled={fetching}
      startIcon={<DownloadIcon />}
      variant="outlined"
      onClick={() => {
        setFetching(true);
        auditReportsGetReportRunsCatalogArtifactUrl(report.id, 'package')
          .then(async (result) => {
            downloadFile(result.url, false);
            await sleep(1000);
          })
          .finally(() => {
            setFetching(false);
          });
      }}
    >
      {$t({
        id: 'audit.broadcastEvidence.downloadPackage',
        defaultMessage: 'Descargar evidencia (ZIP)',
      })}
    </Button>
  );
}
